import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { features, platformStats, testimonials } from '@/mocks/home';
import { Link } from 'react-router-dom';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '俺去也',
  url: 'https://www.anquye.com',
  description: '俺去也是深受用户喜爱的娱乐内容平台，提供海量高清视频资源、极速播放体验与安全稳定的访问通道。无需注册即可免费观看，每日持续更新。',
  foundingDate: '2014',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@anquye.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CN',
    addressLocality: '北京',
  },
};

export default function About() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
                关于俺去也
              </h1>
            </div>
          </div>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-[1280px] mx-auto">
              <div className="flex flex-col lg:flex-row gap-10 items-center">
                <div className="flex-1">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                    品牌故事
                  </h2>
                  <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                    <p>
                      俺去也成立于2014年，从最初的一个小型视频分享站点起步，经过十余年的持续发展，已成长为国内领先的综合性娱乐内容平台。我们始终秉持"让每个人都能轻松享受优质娱乐内容"的初心，致力于为用户提供最丰富、最高清、最便捷的在线娱乐体验。
                    </p>
                    <p>
                      目前，俺去也平台已积累了超过50,000部高清视频资源，涵盖电视剧、电影、综艺、动漫、纪录片、娱乐资讯等六大内容板块。平台日均活跃用户超过8,000万，日均内容更新量超过200部，已成为国内最具影响力的娱乐内容聚合平台之一。
                    </p>
                    <p>
                      我们拥有一支专业的内容运营和技术研发团队，持续优化平台体验，确保用户能够享受到流畅、清晰、安全的在线娱乐服务。无论是内容质量、播放体验还是访问稳定性，俺去也都以最高标准要求自己。
                    </p>
                  </div>
                </div>
                <div className="lg:w-[420px] flex-shrink-0">
                  <div className="rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=modern%20office%20workspace%20with%20creative%20team%20collaborating%2C%20warm%20natural%20light%2C%20clean%20minimal%20design%2C%20professional%20environment%2C%20soft%20atmosphere&width=800&height=600&seq=about-brand-01&orientation=landscape"
                      alt="俺去也团队"
                      className="w-full h-[300px] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  平台数据
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                  数字见证我们的成长
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {[
                  { value: platformStats.totalVideos, label: '高清资源' },
                  { value: platformStats.activeUsers, label: '活跃用户' },
                  { value: platformStats.dailyUpdates, label: '每日更新' },
                  { value: `${platformStats.yearsRunning}年`, label: '运营经验' },
                  { value: `${platformStats.categories}大`, label: '内容板块' },
                  { value: platformStats.satisfaction, label: '用户满意度' },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-5 rounded-xl bg-background-50 border border-background-200"
                  >
                    <div className="text-xl md:text-2xl font-heading font-bold text-primary-600 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-[1280px] mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  核心优势
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                  四大核心优势，打造极致体验
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {features.map((feature, idx) => (
                  <div
                    key={feature.title}
                    className="p-6 rounded-xl bg-background-100 border border-background-200 hover:border-primary-300 transition-all"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                      <i className={`${feature.icon} text-xl text-accent-600`}></i>
                    </div>
                    <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  用户口碑
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                  用户的认可，是我们前行的最大动力
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t) => (
                  <div
                    key={t.name}
                    className="p-6 rounded-xl bg-background-50 border border-background-200"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{t.comment}"
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-9 h-9 rounded-full object-cover"
                      />
                      <span className="text-sm font-medium text-foreground-900">{t.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-[1280px] mx-auto">
              <div className="flex flex-col lg:flex-row gap-10">
                <div className="flex-1">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-8">
                    如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们的客服团队将竭诚为您服务。
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                        <i className="ri-mail-line text-lg text-primary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h4>
                        <p className="text-sm text-foreground-600">contact@anquye.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                        <i className="ri-customer-service-line text-lg text-accent-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-900 mb-1">在线客服</h4>
                        <p className="text-sm text-foreground-600">7 × 24小时全天候在线服务</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                        <i className="ri-map-pin-line text-lg text-secondary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-900 mb-1">公司地址</h4>
                        <p className="text-sm text-foreground-600">中国·北京市朝阳区</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:w-[400px] flex-shrink-0">
                  <div className="rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=modern%20office%20building%20exterior%20with%20glass%20facade%20and%20warm%20sunset%20lighting%2C%20professional%20corporate%20headquarters%2C%20clean%20architectural%20design%2C%20blue%20sky&width=800&height=600&seq=about-contact-01&orientation=landscape"
                      alt="俺去也办公地址"
                      className="w-full h-[300px] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-950 text-background-200 text-center">
            <div className="max-w-[1280px] mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                准备好加入俺去也了吗？
              </h2>
              <p className="text-sm md:text-base text-background-400 max-w-lg mx-auto mb-8">
                无需注册，完全免费。海量高清资源等你来发现！
              </p>
              <Link
                to="/"
                className="inline-flex items-center px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all whitespace-nowrap"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                <i className="ri-home-line mr-2"></i>
                返回首页
              </Link>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}